import { Component } from 'react'
import { StaticValues } from '../../../../../insfrastructure/services/static_values'
import { emptyField, ErrorMessage, errorsLength, formatErrors } from '../../../../../insfrastructure/utils/form-validators'
import Modal from '../../../../components/modal'
import { SubmitBtn } from '../../../../components/submit'
import { Select } from '../../../../components/select'
import repproveIcon from '../../../../../assets/icons/close-red.png'
import { updateJobApply } from '../../../../../insfrastructure/services/job-applies'
import './styles.sass'
import ResponseModal from '../../../../components/response-modal'

interface ModalProps {
    render: boolean,
    candidate: any,
    jobapply_id: any,
    status: 'not_fit' | 'rejected',
    onClose: () => void,
    onSubmitted: () => void
}

export default class RepproveModal extends Component<ModalProps> {
    state: any = {
        form: {},
        formErrors: {},
        loading: false,
        repprove_reasons: []
    }

    componentDidMount() {
        this.getStaticValues();    
    }

    componentDidUpdate(prevProps: Readonly<ModalProps>, prevState: Readonly<{}>, snapshot?: any): void {
        if (prevProps.render !== this.props.render) {
            this.setState({ 
                form: {},
                formErrors: {},
                loading: false
            });    
        };
    }

    getStaticValues = async () => {
        try {  
            const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
        
            const repprove_reasons = Object.keys(staticValues.candidate_submission_reasons)
            .map((key: any) => ({ value: parseInt(key), label: staticValues.candidate_submission_reasons[key] }));
        
            this.setState({ repprove_reasons });
        } catch (error) {
            console.log(error);
        }
    }

    onSubmit = async () => {
        if(this.state.loading) return;

        const errors = formatErrors({
            reason_id: [emptyField(this.state.form.reason_id)]
        });

        this.setState({ formErrors: errors });

        if(errorsLength(errors) > 0) return;

        try {
            this.setState({ loading: true });

            await updateJobApply(this.props.jobapply_id, {
                status: this.props.status,
                reason_id: this.state.form.reason_id
            });

            setTimeout(() => {
                let responseData = {
                    type: 'success',
                    title: 'Candidato reprovado com sucesso'
                };
            
                this.setState({ loading: false, responseData });
            }, 500);
        } catch (error) {};
    }

    render() {
        return (
            <>
                <Modal render={this.props.render && !this.state.responseData} onClose={() => this.props.onClose()}>
                    <div className='repprove-modal'>
                        <div className='modal-header'>
                            <img src={repproveIcon} alt='repprove-icon' />
                            <h4>Marcar <b>{this.props.candidate && this.props.candidate.name}</b> como não apto</h4>
                        </div>
                        <form>
                            <Select
                            name='reason_id'
                            label='Selecione um motivo:'
                            value={this.state.form.reason_id}
                            options={this.state.repprove_reasons}
                            onChange={(e) => {
                                this.setState({ form: { ...this.state.form, reason_id: e }});
                            }}/>
                            <ErrorMessage errors={this.state.formErrors['reason_id']} />
                        </form>
                        <SubmitBtn
                        className='primary'
                        text='Confirmar'
                        loadingText='Confirmando...'
                        onSubmit={this.onSubmit}
                        loading={this.state.loading} />
                    </div>
                </Modal>
                <ResponseModal
                render={this.state.responseData}
                type={this.state.responseData?.type}
                title={this.state.responseData?.title}
                text={this.state.responseData?.text}
                onClose={() => {
                    this.setState({ responseData: null });
                    this.props.onSubmitted();
                }} />
            </>
        )
    }
}
